<template>
	<main id="campaign-pm" class="vx-row justify-center lg:mt-24">
		<div class="vx-col w-full md:w-2/3 lg:w-1/2">
			<div class="flex items-center mb-4" @click="$router.push(`/campaign/${$route.params.id}/detail`)" style="cursor: pointer;">
				<feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
				<strong>Kembali</strong>
			</div>
			<vs-card class="p-6">
				<h5 class="text-primary mb-8">
					<strong>Daftar Penerima Manfaat {{ campaign.title }}</strong>
				</h5>
				<vs-table stripe :data="campaign.list_pm">
					<template slot="thead">
						<vs-th></vs-th>
						<vs-th>Nama Personal/Instansi</vs-th>
						<vs-th>Kontak</vs-th>
					</template>
					<template v-slot="{data}">
						<vs-tr
							v-for="(item, i) in data"
							:key="i"
						>
							<vs-td>
								<img v-if="item.photo == null" src="@/assets/images/profile/default.jpg" alt="" class="w-12 rounded-full" />
								<img v-if="item.photo == null" :src="item.photo" alt="" class="w-12 rounded-full" />
							</vs-td>
							<vs-td>
								<strong>{{item.name}}</strong>
							</vs-td>
							<vs-td>
								{{item.email}}
							</vs-td>
						</vs-tr>
					</template>
				</vs-table>
			</vs-card>
		</div>
	</main>
</template>
<script>
export default {
  data: () => ({
    campaign: {
      id: 1,
      author: {
        image: 'https://xgenious.com/laravel/fundorex/assets/uploads/media-uploader/thumb-pexels-spencer-selover-7753581627279748.jpg',
        name: 'Ikhsan Hamidan'
      },
      saved: '40407525',
      goal: '60000000',
      title: 'Bantu Anak Honorer Lawan Infeksi Corona Paru Akut!',
      slider: {
        url: 'https://imgix.kitabisa.com/3f39c017-d125-46b3-9520-657ba793d409.jpg?ar=16:9&w=664&auto=format,compress&fm=pjpg&cs=tinysrgb&fit=scale'
      },
      remained_time: '',
      percent: '',
      list_pm: [
        {
          id: 1,
          photo: null,
          name: 'Riska Putri',
          email: 'riskaputrii@gmail.com'
        },
        {
          id: 2,
          photo: null,
          name: 'Dovi Ismail',
          email: 'maxsw08@gmail.com'
        },
        {
          id: 3,
          photo: null,
          name: 'Riko Simanjuntak',
          email: 'rksimanjuntak08@gmail.com'
        }
      ]
    }
  })
}
</script>